import domUtils from 'util/dom-utils'
import msg from 'services/msg'
import { arrayFind, getParameters } from 'util/ts-utils'
import { TTDAT_PARAM_NAME } from 'util/turnto-utils'
import { checkForFlow as checkForConfirmationMessageFlow }
  from './confirmation-message-flows' // dp
import { checkForFlow as checkForReviewFlow } from './review-flows' // dp
import { checkForFlow as checkForQaFlow } from './qa-flows' // dp
import { checkForFlow as checkForSrFlow } from './seller-rating-flows' // dp
import { loginUser } from 'services/token-service'
import standalonePopoverLoader from 'widgets/standalone-popover/standalone-popover-loader'

// TODO: This file should be dynamically generated to be included in the page build.
// Only inlude flows (qa, review, etc) that are required.  Perhaps the bundler is given
// a list of flows to check.
// Dynamic lines have "// dp" comment by them

export type TurnToFlow = 'review' | 'rebelmail' // RSE, handled in review flows
  | 'revpr' // purchase required confirmation, handled in review flows
  // handled in confirmation-message-flows
  | 'revcr' // confirmation required review confirmation
  | 'revco' // confirmation optional review confirmation
  | 'qco' // confirmation optional question confirmation
  | 'qcr' // confirmation required question confirmation
  | 'aco' // confirmation optional answer confirmation
  | 'acr' // confirmation required answer confirmation
  | 'repco' // confirmation optional reply confirmation
  | 'repcr' // confirmation required reply confirmation
  // handled in QA flows
  | 'answer' // clicking "answer this question" in question email
  | 'irrelevantq' // clicking not apporpriate link in question email
  | 'optout' // clicking the opt-out link in RSE or question email
  | 'thankanswer' // clicking "reply" from an answer email
  | 'thanka' // clicking "thank" from an answer email
  | 'answerview' // clicking on "see all answers" from answer email
  | 'answerreply' // clicking "reply" from reply email
  | 'replyview' // clicking on "see all answers" from reply email
  | 'sellerrating' // seller rating

// This checks to see if the user reloaded the page.  The interpretation of "reload" is different
// depending on the browser. All will treat the reload/refresh icon click as a realod as well as
// the key command for reload.  What is treated differently is the user clicking in the address
// bar and hitting the enter key.  Chrome treats it as a reload, but most other browsers do not.
function isReload() {
  // for old iOS 7.  Can't support because window.performance is not present.
  if (!window.performance) {
    return false
  }
  if (typeof window.performance['getEntriesByType'] === 'function') {
    // pnt - PerformanceNavigationTiming interface
    const pnt = arrayFind(window.performance.getEntriesByType('navigation'), entry => entry.type)
    if (pnt) {
      return pnt.type !== 'navigate'
    }
  }
  // for the case where the PerformanceNavigationTiming interface is not present, try the
  // deprecated PerformanceNavigation interface
  const pn = window.performance['navigation']
  return !pn || pn.type === undefined ? false : pn.type !== 0
}

export function checkTurntoflow() {
  const params = getParameters()
  let turntoflow = null as TurnToFlow
  if (params.turntoflow) {
    turntoflow = params.turntoflow as TurnToFlow
    if (isReload()) {
      return
    }
    const ttdat = params[TTDAT_PARAM_NAME]
    // if confirmation token is passed, login the user
    if (params.tttok && ttdat) {
      loginUser(params.tttok, ttdat)
    }
    domUtils.onDomReady().then(() => {
      if (params.tterr && params.tterr !== '1101') {
        standalonePopoverLoader.load({
          message: msg(`flowError.${params.tterr}`),
          type: 'error'
        })
        // no need to proceed to any other flows
        return
      }
      checkForConfirmationMessageFlow(turntoflow, params) // dp
      checkForReviewFlow(turntoflow, params) // dp
      checkForQaFlow(turntoflow, params) // dp
      checkForSrFlow(turntoflow, params) // dp
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/email-flows/email-flow-entry.ts